import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import {
  DatastoreSeoNavbarModule,
  DatastoreSiteStatsModule,
  DatastoreUserContestCollaborationWhitelistModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { JobPostSharedModule } from 'app/jobs/job-post/job-post-shared.module';
import { SeoSemArticleItemComponent } from './article-item/article-item.component';
import { CaseStudyItemComponent } from './case-study/case-study-item/case-study-item.component';
import { CaseStudyComponent } from './case-study/case-study.component';
import { FeaturedBrandsModule } from './featured-brands/featured-brands.module';
import { FindNowComponent } from './find-now/find-now.component';
import { GetMoreDoneComponent } from './get-more-done/get-more-done.component';
import { HeroImageCarouselComponent } from './hero/image-carousel/image-carousel.component';
import { SeoSemHeroComponent } from './hero/seo-sem-hero.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { LandingPageSharedModule } from './landing-page-shared.module';
import { MarketplaceStatsComponent } from './marketplace-stats/marketplace-stats.component';
import { MarketplaceStatsRedesignComponent } from './marketplace-stats-redesign/marketplace-stats-redesign.component';
import { ShowcasedWorkCardComponent } from './showcased-work/showcased-work-card/showcased-work-card.component';
import { ShowcasedWorkComponent } from './showcased-work/showcased-work.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { UpsellModule } from './upsell/upsell.module';

@NgModule({
  imports: [
    CommonModule,
    DatastoreSeoNavbarModule,
    DatastoreSiteStatsModule,
    DatastoreUserContestCollaborationWhitelistModule,
    FeaturedBrandsModule,
    LandingPageSharedModule,
    JobPostSharedModule,
    PipesModule,
    TrackingModule,
    UiModule,
    UpsellModule,
    ComponentsModule,
  ],
  declarations: [
    CaseStudyComponent,
    CaseStudyItemComponent,
    FindNowComponent,
    GetMoreDoneComponent,
    HowItWorksComponent,
    MarketplaceStatsComponent,
    MarketplaceStatsRedesignComponent,
    SeoSemHeroComponent,
    ShowcasedWorkComponent,
    ShowcasedWorkCardComponent,
    TestimonialsComponent,
  ],
  exports: [
    CaseStudyComponent,
    CaseStudyItemComponent,
    FindNowComponent,
    GetMoreDoneComponent,
    HeroImageCarouselComponent,
    HowItWorksComponent,
    MarketplaceStatsComponent,
    MarketplaceStatsRedesignComponent,
    SeoSemHeroComponent,
    ShowcasedWorkComponent,
    ShowcasedWorkCardComponent,
    TestimonialsComponent,
    SeoSemArticleItemComponent,
  ],
})
export class SeoSemSharedModule {}
